/**
 * Component for the product-selection page of our Return Portals
 * where customers choose the products they want to return
 * and also give details like Return Reasons.
 * 
 * @component
 */

import { Badge, Button, Card, Checkbox, Col, Divider, Form, Input, List, Popover, Radio, Row, Select, Statistic, Switch, Tooltip, message } from "antd";
import { CheckOutlined, CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import axios from "axios";
import React from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { Currencies, RETURN_TYPES } from "../../constants/constants";
import { getLocale } from "../../helpers/localePortal";
import '../../index.css';
import ExchangeOptions from "./advancedExchanges/ExchangeOptions";
import StoreWideProducts from "./storeWideExchanges/StoreWideProducts";

const { TextArea } = Input;
const FormItem = Form.Item;
const Option = Select.Option;

const innerWidthOfWindow = window.innerWidth;
const isMobile = innerWidthOfWindow && innerWidthOfWindow < 576 ? true : false;
const { Countdown } = Statistic;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  labelAlign: 'left'
};

class Order extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      availableResolutionOptions: [
        "storeCredit",
        "exchangeItem",
        "storeWideExchange",
        "originalPaymentMethod",
        "advancedExchange",
        "refundToCustom1",
        "refundToCustom2",
        "refundToCustom3",
      ],
      resolutionOptionSelected: this.state
        ? this.state.availableResolutionOptions[0]
        : "storeCredit",
      advancedExchangeOptions: {},
      submitButtonDisabled: false,
      loadingExchangeOptions: false,
      exchangeOptionsTitle: undefined,
      exchangeOptionsVisible: false,
      selectedAdvancedExchangeOptions: [],
      advancedExchangeLineItemId: null,
      advancedExchanges: {},
      exchangeSameVariant: true,
      returnReasons: [],
      showProducts:false,
      currentPoduct:{},
      customerLocale: getLocale(),
      shouldHideStoreWideExchangesModal: true,
      expiredItems: [],
      additionalFields: [],
      extraNote: {},
      advancedRuleExtraNotesSetting: {},
      advancedRuleExtraNotes: {},
      labelFee: 0,
      itemQuantity: {},
      hasExchangeResolution: false,
      warrantyFields: [],
      warrantyRules: [],
      warrantyAdditionalFields: [],
      warrantyCustomizeNotes: {},
      warrantyCaseIssues: [],
      requireCaseIssues: false,
      isWarrantyAvailable: false,
    };
  }
  formRef = React.createRef();

  async componentDidMount() {
    // scroll to top of page
    window.scrollTo(0, 0);
    
    this.handlegetReturnReasons()
    // message object from Antd
    // used to remove potentially remaining customer-facing messages as part of the previous component
    message.destroy();
    this.handleBack = this.handleBack.bind(this);
    window.addEventListener('popstate', this.handleBack);
    try {
      const responseWithResolutionOptions = await axios.post("/api/visitors/return/resolutions", {
        companyIdentifier: this.props.companyIdentifier,
        returnNumber: this.props.returnNumber,
      });
      const incentives = responseWithResolutionOptions.data.incentives;
      const dictatingResolutions = incentives?.filter(incentive => {
        return incentive.dictatIncentive === true
      }).map(item => item.dictatResolution)

      let itemQuantity;
      this.props?.orderData?.line_items?.map((product)=> {
        itemQuantity = {
          ...itemQuantity,
          [`quantity_${product.variant_id}`]: 1,
        }
      });
      return this.setState({
        showIncentives: responseWithResolutionOptions.data.showIncentives,
        incentivesResolutions: responseWithResolutionOptions.data.incentivesResolutions,
        incentives,
        dictatingResolutions,
        availableResolutionOptions: responseWithResolutionOptions.data.availableResolutionOptions,
        resolutionOptionSelected: responseWithResolutionOptions.data.availableResolutionOptions[0],
        advancedExchangeOptions: responseWithResolutionOptions.data.advancedExchangeOptions,
        exchangeSameVariant: responseWithResolutionOptions.data.returnSettings.exchangeSameVariant,
        customerLocale: responseWithResolutionOptions.data.customerLocale ? responseWithResolutionOptions.data.customerLocale : 'en',
        additionalFields: responseWithResolutionOptions.data.returnSettings.additionalFields || [],
        warrantyFields: responseWithResolutionOptions.data.returnSettings.warrantyFields || [],
        warrantyRules: responseWithResolutionOptions.data.returnSettings.warrantyRules || [],
        warrantyAdditionalFields: responseWithResolutionOptions.data.returnSettings.warrantyAdditionalFields || [],
        isWarrantyAvailable: !!responseWithResolutionOptions.data.returnSettings.isWarrantyAvailable,
        itemQuantity,
      });
    } catch(err) {
      message.error("Error while loading your resolution options. Please try again.", 4);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.handleBack);
  }

  handleCheckboxChange(productLineItemId, { title, option, checked, target }) {
    const extraNote = this.state.extraNote;
    const advancedRuleExtraNotes = this.state.advancedRuleExtraNotes;
    const note = {};
    if (target === 'additionalFields') {
      const defaultValue = this.state.additionalFields.map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!extraNote[productLineItemId]) {
        extraNote[productLineItemId] = note;
      }
      extraNote[productLineItemId][title].value[option] = checked;
    }
    if (target === 'warrantyAdditionalFields') {
      const defaultValue = this.state.warrantyAdditionalFields.map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!extraNote[`warranty_${productLineItemId}`]) {
        extraNote[`warranty_${productLineItemId}`] = note;
      }
      extraNote[`warranty_${productLineItemId}`][title].value[option] = checked;
    }
    if (target === 'advancedRuleExtraNotesSetting') {
      const defaultValue = this.state.advancedRuleExtraNotesSetting[productLineItemId].map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!advancedRuleExtraNotes[productLineItemId]) {
        advancedRuleExtraNotes[productLineItemId] = note;
      }
      advancedRuleExtraNotes[productLineItemId][title].value[option] = checked;
    }
    this.formRef.current.setFieldsValue({
      [`${target === 'warrantyAdditionalFields' ? 'warrantyCheckbox' : 'checkbox'}_${title}_${productLineItemId}`]: 'checked',
    })
    this.setState({
      extraNote,
      advancedRuleExtraNotes
    });
  }

  handleRadioNoteChange(productLineItemId, { title, option, target}) {
    const extraNote = this.state.extraNote;
    const advancedRuleExtraNotes = this.state.advancedRuleExtraNotes;
    const note = {};
    if (target === 'additionalFields') {
      const defaultValue = this.state.additionalFields.map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!extraNote[productLineItemId]) {
        extraNote[productLineItemId] = note;
      }
      extraNote[productLineItemId][title].value = option;
    }
    if (target === 'warrantyAdditionalFields') {
      const defaultValue = this.state.warrantyAdditionalFields.map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!extraNote[`warranty_${productLineItemId}`]) {
        extraNote[`warranty_${productLineItemId}`] = note;
      }
      extraNote[`warranty_${productLineItemId}`][title].value = option;
    }
    if (target === 'advancedRuleExtraNotesSetting') {
      const defaultValue = this.state.advancedRuleExtraNotesSetting[productLineItemId].map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!advancedRuleExtraNotes[productLineItemId]) {
        advancedRuleExtraNotes[productLineItemId] = note;
      }
      advancedRuleExtraNotes[productLineItemId][title].value = option;
    }
    this.formRef.current.setFieldsValue({
      [`${target === 'warrantyAdditionalFields' ? 'warrantyRadio' : 'radio'}_${title}_${productLineItemId}`]: option,
    })
    this.setState({
      extraNote
    });
  }

  handleCustomNoteChange(productLineItemId, { title, value, target}) {
    const extraNote = this.state.extraNote;
    const advancedRuleExtraNotes = this.state.advancedRuleExtraNotes;
    const note = {};
    if (target === 'additionalFields') {
      const defaultValue = this.state.additionalFields.map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!extraNote[productLineItemId]) {
        extraNote[productLineItemId] = note;
      }
      extraNote[productLineItemId][title].value = value;
    }
    if (target === 'warrantyAdditionalFields') {
      const defaultValue = this.state.warrantyAdditionalFields.map(i => {
        note[i.title] = {
          type: i.type,
          value: {}
        }
      })
      if(!extraNote[`warranty_${productLineItemId}`]) {
        extraNote[`warranty_${productLineItemId}`] = note;
      }
      extraNote[`warranty_${productLineItemId}`][title].value = value;
    }
    if (target === 'advancedRuleExtraNotesSetting') {
      const defaultValue = this.state.advancedRuleExtraNotesSetting[productLineItemId].map(i => {
        note[i.title] = {
          type: 'note',
          value: {}
        }
      })
      if(!advancedRuleExtraNotes[productLineItemId]) {
        advancedRuleExtraNotes[productLineItemId] = note;
      }
      advancedRuleExtraNotes[productLineItemId][title].value = value
    }
    this.formRef.current.setFieldsValue({
      [`${target === 'warrantyAdditionalFields' ? 'warrantyNotes' : 'note'}_${title}_${productLineItemId}`]: value,
    })
    this.setState({
      extraNote
    });
  }

  handleAdvanceNoteChange(productLineItemId, title, value) {
    const advancedRuleExtraNotes = this.state.advancedRuleExtraNotes;
    const note = {};
    const defaultValue = this.state.advancedRuleExtraNotesSetting[productLineItemId].map(i => {
      note[i] = {
        type: 'note',
        value: {}
      }
    })
    if(!advancedRuleExtraNotes[productLineItemId]) {
      advancedRuleExtraNotes[productLineItemId] = note;
    }
    advancedRuleExtraNotes[productLineItemId][title].value = value;
    this.formRef.current.setFieldsValue({
      [`AdvancedRuleNote_${title}_${productLineItemId}`]: value,
    })
    this.setState({
      advancedRuleExtraNotes
    });
  }

  handleBack() {
    this.setState({ ...this.state, shouldHideStoreWideExchangesModal: true });
  }

  async handlegetReturnReasons() {
    try {
      const response = await axios.post("/api/visitors/return/reasons", {
        companyIdentifier: this.props.companyIdentifier,
        returnNumber: this.props.returnNumber,
      });
      if(response) {
        this.setState({
          returnReasons: response.data.returnReasons,
          requireCaseIssues: response.data.requireCaseIssues,
          warrantyCaseIssues: response.data.warrantyCaseIssues,
        });
      }
    } catch (err) {
      return message.error("Something went wrong please try again", 5);
    }
  };

  // Sets and submits the selected line-items for the return
  handleSubmit = async () => {
    const { intl } = this.props;
    try {
      let values = await this.formRef.current.validateFields();
      const extraNote = this.state.extraNote;
      const { advancedRuleExtraNotes } = this.state || {};

      Object.keys(advancedRuleExtraNotes).forEach(key => {
        extraNote[key] = {
          ...extraNote[key],
          ...advancedRuleExtraNotes[key],
        };
      });

      const remainingItems = this.props?.remainingItems;
      if (remainingItems > 0 && this.isExceedingLimit(remainingItems, values)) {
        return message.info(
          intl.formatMessage({
            id: "app.visitor.order.exceedLimitItems",
            description: "Check if the customer has selected more items than allowed",
            defaultMessage: "You have reached the limit of items you can return.",
          }, {
            remainingItems, // Ensure this is defined
          }),
          4
        );
      }
      
      values.extraNote = extraNote;
      values = this.addExchangeVariantIdToValues(values);
      values = this.addReturnTypeToValues(values);

      if (!this.productWasSelected(values)) {
        return message.info(
          intl.formatMessage({
            id: 'app.visitor.order.checkProductSelected',
            defaultMessage: 'Please select at least one product to return.',
          }),
          4
        );
      }

      if (!this.reasonWasSelected(values)) {
        return message.info(
          intl.formatMessage({
            id: 'app.visitor.order.checkReasonSelected',
            defaultMessage: 'Please select a reason for each item you return.',
          }),
          4
        );
      }

      if (!this.resolutionWasSelected(values)) {
        return message.info(
          intl.formatMessage({
            id: 'app.visitor.order.checkResolutionSelected',
            defaultMessage: 'Please select a resolution for each item you return.',
          }),
          4
        );
      }

      const companyIdentifier = this.props.companyIdentifier;
      const returnNumber = this.props.returnNumber;

      this.setState({ submitButtonDisabled: true });
      const { advancedExchanges, expiredItems } = this.state;
      const response = await axios.post('/api/visitors/return/selections', {
        companyIdentifier,
        returnNumber,
        values,
        advancedExchanges,
        expiredItems,
      });

      if (response.data.status === 'error') {
        this.setState({ submitButtonDisabled: false });
        return message.error(response.data.error, 4);
      }
      const updatedReturn = response.data.returnData;
      this.props.updateBrandSettings({
        returnData: updatedReturn,
      });
      const isAllowPhotoUpload = !updatedReturn?.ruleActionCustomerPhotoUpload ? this.props.returnSettings.customerPhotoUploadEnabled : updatedReturn?.ruleActionCustomerPhotoUpload;
      if (isAllowPhotoUpload) {
        return this.props.history.push('/return/resolution');
      } else if (this.props.missingEmailForOrder) {
        return this.props.history.push('/return/info');
      } else if (updatedReturn?.isShippingResolution && this.props.type !== RETURN_TYPES.GIFT_RETURN) {
        return this.props.history.push('/return/address');
      } else {
        return this.props.history.push('/return/method');
      }
    } catch(err) {
      this.setState({
        submitButtonDisabled: false
      });
      return message.error("There was an error communicating with the server. Please try again.", 4);
    }
  }

  showExchangeOptions(value = true) {
    this.setState({
      exchangeOptionsVisible: value,
    });
  }

  closeExchangeOptions(lineItemId = null) {
    if (lineItemId) 
    {
      this.formRef.current.setFieldsValue({
        [`resolution_${lineItemId}`]: undefined,
      })
    }
    this.setState({
      exchangeOptionsVisible: false,
    });
  }

  // Checks if a line-item has been selected or not
  productWasSelected = (values) => {
    let selectedProduct = false;
    this.props.orderData.line_items.map( (product) => {
      const markedProduct = values[`returnItemChecked_${product.id}`];
      if (markedProduct === true) {
        selectedProduct = true;
      }
    });
    return selectedProduct;
  }

  isExceedingLimit = (allowNumber, values) => {
    const listLineItemsReturnIds = Object.keys(values)
      .filter(key => key.startsWith('returnItemChecked_') && values[key] === true)
      .map(key => key.split('_')[1]);
    const totalItemsNumber = listLineItemsReturnIds.reduce((acc, item) => {
      const itemQuantity = values[`returnQuantity_${item}`] || 1;
      return acc + parseInt(itemQuantity, 10);
    }, 0);
    if (totalItemsNumber > allowNumber) {
      return true;
    }
  }

  addExchangeVariantIdToValues = (values) => {
    this.props.orderData.line_items.map( (product) => {
      const selectedExchangeVariantId = this.getSelectedExchangeVariantId(product.id, this.state[`exchangeProductOptions_${product.id}`])
      if(selectedExchangeVariantId){
        values[`exchangeItem_${product.id}`] = selectedExchangeVariantId;
      }
    });
    return values;
  }

  // The Return Type field only exists in the form for merchants on a warranty-capable plan
  // (see showReturnTypeSelector/isWarrantyAvailable in render()); for everyone else it's
  // never rendered, so fall back to whichever flow is actually available for that product
  // (always 'standard' when warranty isn't on the plan at all).
  addReturnTypeToValues = (values) => {
    this.props.orderData.line_items.map( (product) => {
      if (values[`returnType_${product.id}`] === undefined) {
        const { standardEligible, warrantyEligible } = this.getProductEligibility(product);
        values[`returnType_${product.id}`] = (!standardEligible && warrantyEligible) ? 'warranty' : 'standard';
      }
    });
    return values;
  }

  // Checks if a return-reason has been selected for the line-item
  reasonWasSelected = (values) => {
    let reasonSelected = true;
    this.props.orderData.line_items.map( (product) => {
      const markedProduct = values[`returnItemChecked_${product.id}`];
      const selectedReason = values[`returnReason_${product.id}`];
      if (markedProduct === true && selectedReason == null) {
        reasonSelected = false;
      }
    });
    return reasonSelected;
  }

  // Checks if a resoution has been selected for the line-item
  resolutionWasSelected = (values) => {
    let resolutionSelected = true;
    this.props.orderData.line_items.map( (product) => {
      const markedProduct = values[`returnItemChecked_${product.id}`];
      const selectedResolution = values[`resolution_${product.id}`];
      if (markedProduct === true && selectedResolution == null) {
        resolutionSelected = false;
      }
    });
    return resolutionSelected;
  }

  // Formalizes selection of a resolution for the line-item. Differentiates between dynamic exchange and static other options
  // value is STRING --> selected option
  // product is { } --> selected line item
  resolutionSelected = async (value, product) => {
    const response = await axios.post("/api/visitors/return/checkInputChange", {
      companyIdentifier: this.props.companyIdentifier,
      returnNumber: this.props.returnNumber,
      lineItemId: product.id,
      action: value,
      reason: this.formRef.current.getFieldValue(`returnReason_${product.id}`),
      returnType: this.formRef.current.getFieldValue(`returnType_${product.id}`),
    });
    //update action
    if (response.data.status === "error") {
      return message.error(response.data.error, 4);
    }
    this.setState({
      advancedRuleExtraNotesSetting: {
        ...this.state.advancedRuleExtraNotesSetting,
        [product.id]: response.data.titleExtraNotes
      },
      advancedRuleExtraNotes: {},
    });

    if (this.state.showIncentives) {
      const popoverElementsArray = document.querySelectorAll('.ant-popover');
      if (popoverElementsArray.length > 0) {
        popoverElementsArray.forEach(ele => {
          ele.style.display = 'none';
        })
      }
      let incentive
      if (this.state.dictatingResolutions?.includes(value) && this.state[`dictatResolution${product.id}`] !== false) {
        incentive = this.state.incentives.find(incentive => {
          return incentive.dictatResolution === value
        })
        this.setState({
          [`dictate${product.id}`]: true,
          [`dictateAmount${product.id}`]: `${incentive?.incentiveValueType === "fixed" ? `${Currencies[this.props.orderData.currency]}${incentive?.incentiveValue}` : `${incentive?.incentiveValue}%`}`,
          [`dictatResolution${product.id}`]: resolutionOptionsDetail[incentive?.incentiveResolution].identifier,
          [`excludeDictating${product.id}`]: true,
        })
      } else {
        this.setState({
          [`dictate${product.id}`]: false,
          [`${product.id}hideTimer${value}`]: true,
        })
      }
    }
    const lineItemId = product.id;
    this.formRef.current.setFieldsValue({
      [`returnItemChecked_${lineItemId}`]: true,
    });

    const { advancedExchanges } = this.state;
    if(advancedExchanges && advancedExchanges[`products_${product.id}` ])
    {
      advancedExchanges[`products_${product.id}` ] = []
      this.setState({
        advancedExchanges
      });
    }
  
    //if advancedExchange option is selected from portal
    if (value === "advancedExchange") {
      const selectedAdvancedExchangeOptions = this.state.advancedExchangeOptions[
        product.id
      ];
      // set the following information for the current product
      // to completed the functionality and control the UI
      this.setState(
        {
          advancedExchangeLineItemId: lineItemId,
          selectedAdvancedExchangeOptions,
          [`exchangeOptions_${lineItemId}`]: [],
          [`exchangeOptionsTitle_${lineItemId}`]: undefined,
          [`showNotesField_${lineItemId}_exchange`]: false,
          [`showNotesField_${lineItemId}_general`]: true,
        },
        () => this.showExchangeOptions()
      );
    } else if (value === "exchangeItem") {
      const response = await this.exchangeSelected(product);
      const { exchangeOptionsAvailable, exchangeOptionsTitle, exchangeOptions, exchangeProductOptions } = response;
      const resoulution = this.formRef.current.getFieldValue(`resolution_${product.id}`);
      if (exchangeOptionsAvailable === false) {
        this.setState({
          [`showNotesField_${lineItemId}_exchange`]: false,
          [`showNotesField_${lineItemId}_general`]: true,
          [`showNotesField_${lineItemId}_warranty`]: false,
        });
      } else if (resoulution === "exchangeItem"){
        this.setState({
          [`exchangeOptionsTitle_${lineItemId}`]: exchangeOptionsTitle,
          [`exchangeProductOptions_${lineItemId}`]: exchangeProductOptions,
          [`exchangeOptions_${lineItemId}`]: exchangeOptions,
          [`showNotesField_${lineItemId}_exchange`]: false,
          [`showNotesField_${lineItemId}_general`]: true,
          [`showNotesField_${lineItemId}_warranty`]: false,
        });
      }

    } else if (value === "storeWideExchange") {
      this.setState({
        [`showNotesField_${lineItemId}_general`]: true,
        [`showNotesField_${lineItemId}_exchange`]: false,
        [`exchangeOptions_${lineItemId}`]: [],
        [`exchangeOptionsTitle_${lineItemId}`]: undefined,
        [`showNotesField_${lineItemId}_warranty`]: false,
        showProducts:true,
        currentPoduct:product,
        shouldHideStoreWideExchangesModal: false,
      })
    } else {
      // Under a Warranty Claim (returnType_<id> === 'warranty'), any chosen Action shows
      // the warranty notes/additional-fields block instead of the general one - "warranty"
      // used to be a resolution value that triggered this directly; now it's driven by
      // the separate Return Type selector.
      const isWarrantyFlow = this.getFormValue(`returnType_${product.id}`) === 'warranty';
      this.setState({
        [`exchangeOptions_${lineItemId}`]: [],
        [`exchangeOptionsTitle_${lineItemId}`]: undefined,
        [`showNotesField_${lineItemId}_exchange`]: false,
        [`showNotesField_${lineItemId}_general`]: !isWarrantyFlow,
        [`showNotesField_${lineItemId}_warranty`]: isWarrantyFlow,
      });
    }
  }

  handleSelectedProduct = (product) => {
    const variant = product.selectedVariant
    const { id } =  this.state.currentPoduct
    this.updateExchangedProduct({
      lineItemIdToBeExchanged: id,
      productId: product.id,
      productName: product.title,
      variantId: variant.id,
      variantTitle: variant.title,
    })
  }

  hideProducts = (variant) => {
    if (!variant.product_id) {
      this.formRef.current.setFieldsValue({
        [`resolution_${this.state.currentPoduct.id}`]: undefined,
      })
    }
    this.setState({
      showProducts:false,
    })
  }

  // Loads the available exchange options for the product
  exchangeSelected = async (product) => {
    const companyIdentifier = this.props.companyIdentifier;
    const returnNumber = this.props.returnNumber;
    const lineItemId = product.id;
    const lineItemReturnQuantity = this.formRef.current.getFieldValue(`returnQuantity_${lineItemId}`);

    try {
      this.setState({
        loadingExchangeOptions: true
      });
    
      const response = await axios.post("/api/visitors/return/exchange", {
        companyIdentifier,
        returnNumber,
        lineItemId,
        lineItemReturnQuantity,
      });

      if (response.data.status === "error") {
        this.setState({
          loadingExchangeOptions: false
        });
        return message.error("There was an error loading your exchange options. Try again or fill out the notes field with your exchange instructions if the error persists.", 5);
      }

      this.setState({
        loadingExchangeOptions: false
      });
      return response.data;
    } catch(err) {
      this.setState({
        loadingExchangeOptions: false
      });
      return message.error("There was an error loading your exchange options. Try again or fill out the notes field with your exchange instructions if the error persists.", 5);
    }
  }

  // Loads return reasons for each line-item, option to shuffle reasons
  // Warranty Claims use ReturnSetting.warrantyCaseIssues instead of the Standard reason
  // list, but only when "Enforce Case Issues" is on - otherwise both return types share
  // the same list. See docs/warranty-return-type-plan.md, section 2.5.
  getReturnReasons(returnType = 'standard') {
    let returnReasonsElements = [];
    const useWarrantyCaseIssues = returnType === 'warranty' &&
      this.state.requireCaseIssues &&
      this.state.warrantyCaseIssues &&
      this.state.warrantyCaseIssues.length > 0;
    const reasonsSource = useWarrantyCaseIssues
      ? this.state.warrantyCaseIssues
      : this.state.returnReasons;

    if (reasonsSource && reasonsSource.length > 0) {
      let reasonsArray = reasonsSource;

      if(this.props.returnSettings.shuffleReturnReasons){
        reasonsArray = this.shuffleArray(reasonsSource);
      }

      returnReasonsElements = reasonsArray.map((reason, index) => {
        const locale = getLocale();
        const selectedLanguage = (reason.translations || []).find((translation)=> translation.language === locale)
        // Warranty case issues have a different shape than standard return reasons
        // ({ caseIssue: "..." } vs. { id, reason, translations }) and aren't translatable,
        // so pull the right field instead of always reading reason.reason (which is
        // undefined for case issues and rendered as a blank/undefined option).
        const value = useWarrantyCaseIssues ? reason.caseIssue : reason.reason;
        return (
          <Option value={value} key={reason.id || `${value}_${index}`}>
            {selectedLanguage ? selectedLanguage.translation : value}
          </Option>
        );
      });
    } else if (!useWarrantyCaseIssues) {
      if (this.props.returnSettings && this.props.returnSettings.returnReasons) {
        const returnReasons = this.props.returnSettings.returnReasons;
        let arrayOfReturnReasons = returnReasons.split(/\r?\n/);
        
        if(this.props.returnSettings.shuffleReturnReasons)
        {
          arrayOfReturnReasons = this.shuffleArray(arrayOfReturnReasons);
        }
  
        returnReasonsElements = arrayOfReturnReasons.map((reason) => {
          return (
            <Option value={reason} key={reason}>
              {reason}
            </Option>
          );
        });
      }
    }
    return returnReasonsElements;
  }

  // Randomizes array of return reasons if enabled by the user
  shuffleArray(originalArray) {
    const array = [...originalArray];
    let currentIndex = array.length,
      temporaryValue,
      randomIndex;

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  }

  // reset any selected options from a collection-exchange
  clearAdvancedExchange(lineItemIdToBeExchanged) {
    if (lineItemIdToBeExchanged) 
    {
      this.formRef.current.setFieldsValue({
        [`resolution_${lineItemIdToBeExchanged}`]: undefined,
      })
    }
    const { advancedExchanges } = this.state;
    
    advancedExchanges[
      `products_${lineItemIdToBeExchanged}`
    ] = [];
    
    advancedExchanges[
      `exchangedItemProductName_${lineItemIdToBeExchanged}`
    ] = undefined;
    advancedExchanges[
      `exchangedItemProductId_${lineItemIdToBeExchanged}`
    ] = undefined;
    advancedExchanges[
      `exchangedVariantId_${lineItemIdToBeExchanged}`
    ] = undefined;

    this.setState({
      [`advancedExchangeSelected_${lineItemIdToBeExchanged}`]: true,
      advancedExchanges,
    });
  }

  handleVisibilityChange = (visible, lineItemId, item) => {
    this.setState({
      [`${lineItemId}${item}timer`]: visible,
    });
  }

  onFinish = (lineItemId,item) => {
    this.setState({
      [`${lineItemId}hideTimer${item}`]: true,
      [`dictatResolution${lineItemId}`]: false,
      expiredItems : [
        ...this.state.expiredItems,
        {
          item,
          lineItemId,
        },
      ],
    }, () => this.getAvailableOptions(lineItemId))
  }

  getWarrantyRuleToApply = (variantId) => {
    const warrantyRules = this.state.warrantyRules || [];
    if (warrantyRules.length > 0) {
      return warrantyRules.find(rule =>
        rule.warrantyProducts?.some(product => String(product.variantId) === String(variantId))
      );
    }

    // Legacy fallback for companies that haven't been migrated from the old
    // ReturnSetting.warrantyFields JSON to WarrantyRule rows yet (see
    // server/db/migrations/20260629090000-WarrantyRules-feature.js). These entries
    // predate the Return Type redesign and have no `resolutionOptions`, so
    // getProductEligibility() will treat them as not warranty-eligible for the new
    // selector until the merchant configures a proper WarrantyRule with Return Options.
    const warrantyFields = this.state.warrantyFields || [];
    return warrantyFields.find(field =>
      field.warrantyProducts?.some(product => String(product.variantId) === String(variantId))
    );
  }

  isWarrantyExpired = (warrantyToApply) => {
    if (!warrantyToApply?.warrantyTimeLimit) return false;

    const creationDate = new Date(warrantyToApply?.creationDate).getTime();
    if (Number.isNaN(creationDate)) return false;

    const warrantyPeriod = warrantyToApply.warrantyTimeLimit * 24 * 60 * 60 * 1000;
    const expirationDate = creationDate + warrantyPeriod;
    return Date.now() > expirationDate;
  }

  // Whether Standard Return and/or Warranty Claim are available for a line item. A
  // Warranty Claim overrides an Advanced-Rule block (product.disabledFromRules) - that's
  // what "Warranty Rules take precedence over Advanced Rules" means concretely here (see
  // docs/warranty-return-type-plan.md). A product removed from the store is always
  // unreturnable regardless of return type.
  getProductEligibility = (product) => {
    const warrantyToApply = this.getWarrantyRuleToApply(product.variant_id);
    // isWarrantyAvailable reflects the merchant's subscription (Subscription.featureWarranty,
    // set server-side in server/app/services/portal/resolution.js, copied into state in
    // componentDidMount - it lives on this.state, not this.props.returnSettings, since the
    // /resolutions response is destructured field-by-field into state there). Without this
    // check a merchant who downgraded off a warranty-capable plan could still have customers
    // routed into a warranty flow purely because old WarrantyRule rows are still in the DB.
    const warrantyEligible = !!this.state.isWarrantyAvailable &&
      !product.deletedFromStore &&
      !!warrantyToApply &&
      Array.isArray(warrantyToApply.resolutionOptions) &&
      warrantyToApply.resolutionOptions.length > 0 &&
      !this.isWarrantyExpired(warrantyToApply);
    // isStandardEligible reflects whether the order's delivery date is still within the
    // Advanced Rule/General Settings return timeframe (see getReturnTimeframe in
    // server/app/integrations/shopify/order.js) - it's order-wide (all items share the same
    // delivery date), unlike warrantyEligible which is resolved per variant above. It lives on
    // returnData (computed per return instance), not returnSettings (static merchant config).
    const standardEligible = !!this.props.returnData?.isStandardEligible &&
      !product.deletedFromStore &&
      !product.isExcludedFromReturns &&
      !product.disabledFromRules;
    return { standardEligible, warrantyEligible, warrantyToApply };
  }

  isProductUnavailable = (product) => {
    const { standardEligible, warrantyEligible } = this.getProductEligibility(product);
    return !standardEligible && !warrantyEligible;
  }

  // Resets everything that depends on the chosen Return Type (Action, Reason, notes,
  // additional-fields, any in-progress exchange selection) so a "Warranty-only" choice
  // never leaks into the Standard flow, or vice versa, when the customer changes their
  // mind. Mirrors resetProductFields() but keeps the product checked.
  returnTypeSelected = (value, product) => {
    const lineItemId = product.id;
    const extraNote = this.state.extraNote;
    delete extraNote[lineItemId];
    delete extraNote[`warranty_${lineItemId}`];

    const { advancedExchanges } = this.state;
    if (advancedExchanges && advancedExchanges[`products_${lineItemId}`]) {
      advancedExchanges[`products_${lineItemId}`] = [];
    }

    this.formRef.current.setFieldsValue({
      [`resolution_${lineItemId}`]: undefined,
      [`returnReason_${lineItemId}`]: undefined,
      [`notes_${lineItemId}`]: undefined,
      [`warrantyNotes_${lineItemId}`]: undefined,
    });

    this.setState({
      extraNote,
      advancedExchanges,
      advancedRuleExtraNotesSetting: {
        ...this.state.advancedRuleExtraNotesSetting,
        [lineItemId]: [],
      },
      [`exchangeOptions_${lineItemId}`]: [],
      [`exchangeOptionsTitle_${lineItemId}`]: undefined,
      [`showNotesField_${lineItemId}_exchange`]: false,
      [`showNotesField_${lineItemId}_general`]: false,
      [`showNotesField_${lineItemId}_warranty`]: false,
      [`returnTypeSelected_${lineItemId}`]: value,
    });
  }

  // creating return options dynamically for every product
  getAvailableOptions(lineItemId, price, variantId, returnType = 'standard') {
    const customOptions = [
      "refundToCustom1",
      "refundToCustom2",
      "refundToCustom3",
    ];
    const { formatMessage } = this.props.intl;
    const warrantyToApply = this.getWarrantyRuleToApply(variantId);

    // Warranty Claim: Action list comes from the matching WarrantyRule's own Return
    // Options (server/app/services/warrantyRules.js#getWarrantyResolutionOptionsForRule),
    // never from Standard settings/Advanced Rules (Warranty Rules take precedence - see
    // docs/warranty-return-type-plan.md). Incentive badges are a Standard-flow concept
    // only, so this branch skips that logic entirely.
    if (returnType === 'warranty') {
      if (!warrantyToApply) return [];
      const options = [...(warrantyToApply.resolutionOptions || [])];
      if (
        warrantyToApply.optionStoreWideExchange &&
        this.state.availableResolutionOptions.includes('storeWideExchange')
      ) {
        options.push('storeWideExchange');
      }
      const warrantyOptions = options
        .filter((identifier) => resolutionOptionsDetail[identifier])
        .map((identifier) => (
          <Option value={identifier} key={identifier}>
            {customOptions.includes(identifier)
              ? (this.props.returnSettings[`${identifier}Label`] || resolutionOptionsDetail[identifier].identifier)
              : resolutionOptionsDetail[identifier].title}
          </Option>
        ));
      if (
        warrantyToApply.optionAdvancedExchange &&
        this.state.advancedExchangeOptions[lineItemId] &&
        this.state.advancedExchangeOptions[lineItemId].length > 0
      ) {
        warrantyOptions.unshift(
          <Option
            value={resolutionOptionsDetail["advancedExchange"].identifier}
            key={resolutionOptionsDetail["advancedExchange"].identifier}
          >
            {resolutionOptionsDetail["advancedExchange"].title}
          </Option>
        );
      }
      return warrantyOptions;
    }

    const availableOptions = this.state.availableResolutionOptions.map(
      (item) => {
        if (this.state.showIncentives) {
          const incentive = this.state.incentivesResolutions.includes(item) ? this.state.incentives?.find(incentive => {
            return item === incentive?.incentiveResolution
          }) : undefined

          if (incentive && (!incentive.dictatIncentive || this.state[`excludeDictating${lineItemId}`])) {

            if (incentive.enableTimer && !this.state[`${lineItemId}hideTimer${item}`]) {
              return <Option
                value={resolutionOptionsDetail[item].identifier}
                key={resolutionOptionsDetail[item].identifier}
                className="inscentivesBadge"
              >
                <Popover
                  trigger="hover"
                  style={{backgroundColor: this.props.brandIncentivesColor }} 
                  placement="right"  
                  title={""} 
                  visible={this.state[`${lineItemId}${item}timer`]}
                  onVisibleChange={(value) => this.handleVisibilityChange(value, lineItemId, item)} 
                  content={
                    <Countdown 
                      title={<span style={{color:"red"}}>{formatMessage({
                        id:"app.visitor.incentive.timerEnding",
                        description:"duration of incentive timer",
                        defaultMessage:"Offer ends in",
                      })}</span>} 
                      value={this.state[`${lineItemId}deadline`] + ((parseFloat(incentive.timerValue) -1) * 60000)} // Convert minutes to milliseconds
                      format="mm:ss" 
                      onFinish={() => this.onFinish(lineItemId,item)} 
                      arrowPointAtCenter
                    />
                  }
                >
                  <Badge
                    style={{backgroundColor:this.props.brandIncentivesColor}} 
                    count={`${incentive.incentiveValueType === "fixed" ? `+ ${Currencies[this.props.orderData.currency]}${incentive.incentiveValue}` : `+${incentive.incentiveValue}%`} ${formatMessage({
                      id:`${incentive.incentiveType === "Discount Code" ? "app.visitor.incentive.discountCode" : "app.visitor.resolutions.storeCreditTitle"}`,
                      description:"type of incentive discount code/store credit",
                      defaultMessage:incentive.incentiveType,
                    })}`} offset={[70,0]}>
                    {customOptions.includes(resolutionOptionsDetail[item].identifier)
                      ? this.props.returnSettings[
                          `${resolutionOptionsDetail[item].identifier}Label`
                      ]
                      : <span style={{ width: "70%", textWrap: 'auto'}}>{resolutionOptionsDetail[item].title}</span>}
                  </Badge>
                </Popover>
              </Option>

            } else if (!incentive.enableTimer) {
              return <Option
                value={resolutionOptionsDetail[item].identifier}
                key={resolutionOptionsDetail[item].identifier}
                className="inscentivesBadge"
              >
                <Badge
                  style={{backgroundColor:this.props.brandIncentivesColor}} 
                  count={`${incentive.incentiveValueType === "fixed" ? `+${Currencies[this.props.orderData.currency]} ${incentive.incentiveValue}` : `+${incentive.incentiveValue}%`} ${formatMessage({
                    id:`${incentive.incentiveType === "Discount Code" ? "app.visitor.incentive.discountCode" : "app.visitor.resolutions.storeCreditTitle"}`,
                    description:"type of incentive discount code/store credit",
                    defaultMessage:incentive.incentiveType,
                  })}`} offset={[70,0]}>
                  {customOptions.includes(resolutionOptionsDetail[item].identifier)
                    ? this.props.returnSettings[
                        `${resolutionOptionsDetail[item].identifier}Label`
                    ]
                    : <span style={{ width: "70%", textWrap: 'auto'}}>{resolutionOptionsDetail[item].title}</span>}
                </Badge>
              </Option>

            }
          }
        }
        return (
          <Option
            value={resolutionOptionsDetail[item].identifier}
            key={resolutionOptionsDetail[item].identifier}
          >
            {customOptions.includes(resolutionOptionsDetail[item].identifier)
              ? this.props.returnSettings[
                  `${resolutionOptionsDetail[item].identifier}Label`
              ] ? this.props.returnSettings[
                    `${resolutionOptionsDetail[item].identifier}Label`
              ] : resolutionOptionsDetail[item].identifier
              : resolutionOptionsDetail[item].title}
          </Option>
        );
      }
    );

    if (
      this.state.advancedExchangeOptions[lineItemId] &&
      this.state.advancedExchangeOptions[lineItemId].length > 0
    ) {
      const incentive = this.state.incentivesResolutions.includes("advancedExchange") ? this.state.incentives?.find(incentive => {
        return incentive?.incentiveResolution === "advancedExchange"
      }) : undefined;

      if (this.state.showIncentives && incentive?.incentiveResolution === "advancedExchange" && (!incentive.dictatIncentive || this.state[`excludeDictating${lineItemId}`]) && !this.state[`${lineItemId}hideTimeradvancedExchange`]) {
        if (incentive.enableTimer) {
          availableOptions.unshift(
            <Option
              value={resolutionOptionsDetail["advancedExchange"].identifier}
              key={resolutionOptionsDetail["advancedExchange"].identifier}
              className="inscentivesBadge"
            >
              <Popover
                trigger="hover"
                style={{backgroundColor: this.props.brandIncentivesColor }} 
                placement="right"  
                title={""} 
                visible={this.state[`${lineItemId}advancedExchangetimer`]}
                onVisibleChange={(value) => this.handleVisibilityChange(value, lineItemId, "advancedExchange")} 
                content={
                  <Countdown 
                    title={<span style={{color:"red"}}>{formatMessage({
                      id:"app.visitor.incentive.timerEnding",
                      description:"duration of incentive timer",
                      defaultMessage:"Offer ends in",
                    })}</span>} 
                    value={this.state[`${lineItemId}deadline`] + ((parseFloat(incentive.timerValue) -1) * 60000)} // Convert minutes to milliseconds
                    format="mm:ss" 
                    onFinish={() => this.onFinish(lineItemId,"advancedExchange")} 
                    arrowPointAtCenter
                  />
                }
              >
                <Badge
                  style={{backgroundColor:this.props.brandIncentivesColor}} 
                  count={`${incentive.incentiveValueType === "fixed" ? `+ ${Currencies[this.props.orderData.currency]}${incentive.incentiveValue}` : `+${incentive.incentiveValue}%`} ${formatMessage({
                    id:`${incentive.incentiveType === "Discount Code" ? "app.visitor.incentive.discountCode" : "app.visitor.resolutions.storeCreditTitle"}`,
                    description:"type of incentive discount code/store credit",
                    defaultMessage:incentive.incentiveType,
                  })}`} offset={[70,0]}>
                  <span style={{ width:"70%"}}>{resolutionOptionsDetail["advancedExchange"].title}</span>
                </Badge>
              </Popover>
            </Option>
          )
        } else {
          availableOptions.unshift(
            <Option
              value={resolutionOptionsDetail["advancedExchange"].identifier}
              key={resolutionOptionsDetail["advancedExchange"].identifier}
              className="inscentivesBadge"
            >
              <Badge 
                style={{backgroundColor:this.props.brandIncentivesColor}} 
                count={`${incentive.incentiveValueType === "fixed" ? `+${Currencies[this.props.orderData.currency]} ${incentive.incentiveValue}` : `+${incentive.incentiveValue}%`} ${incentive.incentiveType}`} offset={[70,0]}
              >
                <span style={{ width:"70%"}}>{resolutionOptionsDetail["advancedExchange"].title}</span>
              </Badge>
            </Option>
          );
        }
      } else {
        availableOptions.unshift(
          <Option
            value={resolutionOptionsDetail["advancedExchange"].identifier}
            key={resolutionOptionsDetail["advancedExchange"].identifier}
          >
            {resolutionOptionsDetail["advancedExchange"].title}
          </Option>
        );
      }
    }

    return availableOptions;
  }

  // Set the collection exchange information about the product based on lineItemId
  updateExchangedProduct = (productInfo) => {
    const {
      lineItemIdToBeExchanged,
      productId,
      productName,
      variantId,
    } = productInfo;
    const { advancedExchanges } = this.state;

    advancedExchanges[
      `products_${lineItemIdToBeExchanged}`
    ] = [productInfo];
    
    advancedExchanges[
      `exchangedItemProductName_${lineItemIdToBeExchanged}`
    ] = productName;
    advancedExchanges[
      `exchangedItemProductId_${lineItemIdToBeExchanged}`
    ] = productId;
    advancedExchanges[
      `exchangedVariantId_${lineItemIdToBeExchanged}`
    ] = variantId;

    this.setState({
      [`advancedExchangeSelected_${lineItemIdToBeExchanged}`]: true,
      advancedExchanges,
      advancedExchangeLineItemId: null,
    });
  };

  // Updating the quantity of a line-item can change availability of e.g. exchange items. Hence reset any previous selections
  updateQuantityOfLineItem(value, lineItemId, variantId) {
    this.formRef.current.setFieldsValue({
      [`resolution_${lineItemId}`]: undefined,
    });
    const itemQuantity = this.state.itemQuantity;
    itemQuantity[`quantity_${variantId}`] = value;
    this.setState({
      [`exchangeOptions_${lineItemId}`]: [],
      [`exchangeOptionsTitle_${lineItemId}`]: undefined,
      [`showNotesField_${lineItemId}_exchange`]: false,
      [`showNotesField_${lineItemId}_general`]: false,
      itemQuantity,
    });
  }
  
  onChangeReason = async (value, lineItemId) => {
    //check reason with advance rule
    const response = await axios.post("/api/visitors/return/checkInputChange", {
      companyIdentifier: this.props.companyIdentifier,
      returnNumber: this.props.returnNumber,
      lineItemId,
      reason: value,
      action:  this.formRef.current.getFieldValue(`resolution_${lineItemId}`),
      returnType: this.formRef.current.getFieldValue(`returnType_${lineItemId}`),
    });
    //update action
    if (response.data.status === "error") {
      return message.error(response.data.error, 4);
    }
    this.setState({
      advancedRuleExtraNotesSetting: {
        ...this.state.advancedRuleExtraNotesSetting,
        [lineItemId]: response.data.titleExtraNotes
      },
    });
  };

  handleExchangeVariantPropertySelection(value, productOption, productId){
    const newExchangeProductOptions = [];
    for(const exchangeProductOption of this.state[`exchangeProductOptions_${productId}`]){
      if(exchangeProductOption.id === productOption.id){
        newExchangeProductOptions.push({...productOption, valueSelected: value})
      }
      else{
        newExchangeProductOptions.push(exchangeProductOption)
      }
    }
    for(const option of newExchangeProductOptions){
      if(option.valueSelected){
        const isDisabled = this.isExchangeVariantPropertyDisabled(option.valueSelected, option, productId, newExchangeProductOptions);
        if(isDisabled.disabled){
          option.valueSelected = undefined;
          this.formRef.current.setFieldsValue({
            [`exchangeItem_${productId}_${option.id}`]: undefined,
          });
        }
      }
    }
    this.setState({
      ...this.state,
      [`exchangeProductOptions_${productId}`]: newExchangeProductOptions
    })

    this.formRef.current.setFieldsValue({
      [`exchangeItem_${productId}_${productOption.id}`]: value,
    });
  }

  getFormValue = (field) => {
    if (this.formRef && this.formRef.current) {
      return this.formRef.current.getFieldValue(field);
    }
    return undefined;
  };

  isExchangeVariantPropertyDisabled(optionValue, productOption, productId, exchangeProductOptions){
    let exchangeOptions = [...this.state[`exchangeOptions_${productId}`]];
    const optionIndex = exchangeProductOptions.findIndex(option => option.id === productOption.id);
    const selectedOptions = exchangeProductOptions.slice(0, optionIndex).filter(productOption => productOption.valueSelected);
    for(const selectedOption of selectedOptions){
      exchangeOptions=exchangeOptions.filter(exchangeOption => {
        const variantOption = exchangeOption.variantProductOptions.find(variantOption => variantOption.id === selectedOption.id && variantOption.value === selectedOption.valueSelected);
        if(variantOption){
          return true;
        }
        return false;
      })
    }
    let disabledReason = "";
    exchangeOptions=exchangeOptions.filter(exchangeOption => {
      const hasProperty = exchangeOption.variantProductOptions.find(variantOption => variantOption.id === productOption.id && variantOption.value === optionValue);
      if (!this.props.returnSettings?.exchangeSameVariant) {
        const product = this.props.orderData?.line_items?.find( product => product.id === productId);
        if (product?.variant_id === exchangeOption.exchangeVariantId) {
          exchangeOption.disabled = true;
        }
      }
      if(hasProperty && exchangeOption.disabled === false){
        return true;
      } else if(hasProperty && exchangeOption.disabled === true) {
        disabledReason = exchangeOption.disabledReason ? exchangeOption.disabledReason : '';
      }
      return false;
    })
    return {
      disabled: exchangeOptions.length === 0,
      disabledReason
    }
  }

  getSelectedExchangeVariantId(productId, exchangeProductOptions){
    const areAllOptionsSelected = exchangeProductOptions?.every(productOption => productOption.valueSelected)
    const optionVariant = this.state[`exchangeOptions_${productId}`]?.find(exchangeOption => {
      if(exchangeOption.disabled){
        return false
      }
      for(
        const variantOption of exchangeOption.variantProductOptions
      ){
        const selectedOption = exchangeProductOptions.find(productOption => productOption.id === variantOption.id)
        if(selectedOption.valueSelected !== variantOption.value){
          return false
        }
      }
      return true
    })
    
    if(areAllOptionsSelected && optionVariant){
      return optionVariant.exchangeVariantId;
    }
  }

  resetProductFields = (checked, product) => {
    if (!checked) {
      const productId = product.id;
      const fieldsToReset = [
        `resolution_${productId}`,
        `returnReason_${productId}`,
        `notes_${productId}`,
        `warrantyNotes_${productId}`,
      ];

      const { advancedExchanges } = this.state;
      if (advancedExchanges && advancedExchanges[`products_${productId}`]) {
        advancedExchanges[`products_${productId}`] = [];
        this.setState({ advancedExchanges });
      }

      const formValues = {};
      fieldsToReset.forEach(field => {
        formValues[field] = undefined;
      });

      // Don't blank out Return Type - when only one type is eligible the field is shown
      // preselected and disabled (see showReturnTypeSelector/lockedReturnType in render()),
      // and it must stay that way while the item is toggled off too. When both types are
      // eligible, mirror the same default the field mounts with (returnTypeInitialValue in
      // render()) - "Standard Return" - rather than leaving it empty; the customer can still
      // change it once they re-enable the item and interact with the field.
      const { standardEligible, warrantyEligible } = this.getProductEligibility(product);
      const onlyOneReturnTypeEligible = standardEligible !== warrantyEligible;
      const lockedReturnType = onlyOneReturnTypeEligible
        ? (warrantyEligible ? 'warranty' : 'standard')
        : undefined;
      formValues[`returnType_${productId}`] = lockedReturnType || 'standard';

      if (this.formRef && this.formRef.current) {
        this.formRef.current.setFieldsValue(formValues);
      }

      this.setState({
        [`exchangeOptions_${productId}`]: [],
        [`exchangeOptionsTitle_${productId}`]: undefined,
        [`showNotesField_${productId}_exchange`]: false,
        [`showNotesField_${productId}_general`]: false,
        [`showNotesField_${productId}_warranty`]: false,
        // Also clear any Advanced/Warranty Rule custom note picked up for this line item -
        // otherwise it stays registered as a required Form.Item after the customer toggles
        // the item off, and Form validation on submit keeps blocking on a field for a
        // product that isn't even being returned anymore.
        advancedRuleExtraNotesSetting: {
          ...this.state.advancedRuleExtraNotesSetting,
          [productId]: [],
        },
      });
    }
  }
  handleExchangeTypeChange = (e, productId) => {
    this.formRef.current.setFieldsValue({
      [`selectedInstantExchange_${productId}`]: e.target.value,
    });
  };

  updateHasExchangeResolution = (value, product, isChecked = null) => {
    const values = this.formRef.current.getFieldsValue();
    const resolutionKey = `resolution_${product.id}`;
    const returnItemCheckedKey = `returnItemChecked_${product.id}`;
  
    const updatedValues = {
      ...values,
    };
  
    if (value !== null) {
      updatedValues[resolutionKey] = value;
    }
  
    if (isChecked !== null) {
      updatedValues[returnItemCheckedKey] = isChecked;
    }
  
    const resolutionValues = Object.keys(updatedValues)
      .filter((key) => key.startsWith('resolution_'))
      .filter((key) => {
        const itemId = key.split('_')[1];
        const returnItemChecked = updatedValues[`returnItemChecked_${itemId}`];
        return returnItemChecked;
      })
      .map((key) => updatedValues[key])
      .filter((val) => val);
  
    const hasExchangeResolution = resolutionValues.some(
      (res) =>
        res === 'exchangeItem' ||
        res === 'advancedExchange' ||
        res === 'storeWideExchange'
    );
  
    this.setState({ hasExchangeResolution });
  };

  isExchangeResolution = (productId) => {
    const resolution = this.formRef.current?.getFieldValue(`resolution_${productId}`);
    return ['exchangeItem', 'advancedExchange', 'storeWideExchange'].includes(resolution);
  };

  render() {
    const { formatMessage } = this.props.intl;
    // TODO: upgrade antd to 5.x and remove this
    // add css in antd after render
    setTimeout(() => {
      const doc = document.getElementsByClassName('ant-form-item-label');
      for(let i = 0 ; i < doc.length ; i++) {
        doc[i].style.whiteSpace = 'break-spaces';
        doc[i].style.width = '100%';
      }
    }, 0);
    // TODO end
    const placeholderInput = defineMessages({
      notesExchange: {
        id: "app.visitor.order.notesExchange",
        description: "additional notes for exchange of product",
        defaultMessage: "Please indicate the details of your exchange.",
      },
      notesGeneral: {
        id: "app.visitor.order.notesGeneral",
        description: "additional notes for everything other than an exchange",
        defaultMessage: "Optional notes. Give us further details about your return.",
      },
      dictateMessage: {
        id:"app.visitor.incentive.dictatMessage",
        description:"type of incentive discount code/store credit",
        defaultMessage:"Get up to {bonusAmount} if you opt for {dictateResolution}",
      },
      disabledProduct: {
        id:"app.visitor.order.disabledProduct",
        description:"message for the products disbaled from advanced rules.",
        defaultMessage:"This product is ineligible for a return. For more information, contact us at {email_address}.",
      }
    });

    const productList = !this.props.orderData.line_items
      ? "Loading"
      : this.props.orderData.line_items.map( (product, index) => {
        const insertDivider = (index !== this.props.orderData.line_items.length-1)
          ? <Row>
            <Col>
              <Divider />
            </Col>
          </Row>
          : "";
        const quantitySelectionArray = [];
        for (let i=1;i<=product.quantity;i++) {
          quantitySelectionArray.push(i);
        }
        const quantitySelectionElements = quantitySelectionArray.map( (item) => {
          return <Option value={ item } key={ item }>{ item }</Option>;
        });

        const { standardEligible, warrantyEligible } = this.getProductEligibility(product);
        const productUnavailable = !standardEligible && !warrantyEligible;
        const isWarrantyAvailable = !!this.state.isWarrantyAvailable;
        // To make clear to the customer which kind of return this is, the Return Type
        // field is always shown for any returnable item once the merchant's plan includes
        // warranty - even when only one type actually applies. When exactly one of the two
        // is eligible, that type is preselected and the field is locked (see disabled prop
        // below); when both are eligible the customer still has to choose. Merchants
        // without the warranty plan never see this field at all - same as before.
        const showReturnTypeSelector = isWarrantyAvailable && (standardEligible || warrantyEligible);
        const onlyOneReturnTypeEligible = standardEligible !== warrantyEligible;
        const lockedReturnType = onlyOneReturnTypeEligible
          ? (warrantyEligible ? 'warranty' : 'standard')
          : undefined;
        const returnTypeInitialValue = lockedReturnType || 'standard';
        const selectedReturnType = this.getFormValue(`returnType_${product.id}`) ||
          (showReturnTypeSelector ? returnTypeInitialValue : (warrantyEligible ? 'warranty' : 'standard'));

        const productElement =
          (
            <React.Fragment key={ product.id }>
              <Row type="flex" justify="center" align="middle" className={this.state.showIncentives ? "returnProducts u-rowGap--md" : "u-rowGap--md"}>
                <Col md={2} xs={24}>
                  <FormItem
                    name={`returnItemChecked_${product.id}`}
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Switch
                      onChange={(checked) => {
                        this.updateHasExchangeResolution(null, product, checked);
                        this.resetProductFields(checked, product)
                      }} 
                      disabled={productUnavailable}
                      style={{ marginBottom: 5 }}
                      checkedChildren={<CheckOutlined />}
                      unCheckedChildren={<CloseOutlined />}
                    />
                  </FormItem>
                  {
                    productUnavailable
                      ? (<FormattedMessage
                        id="app.visitor.order.notEligible"
                        description="Product is not eligible for return"
                        defaultMessage="Not eligible for return"
                        values={{
                        }}
                      />)
                      : ""
                  }
                </Col>
                <Col md={4} xs={24}>
                  <img src={ this.props.productData[`${product.product_id}-${product.variant_id}`] } style={{ maxHeight: 100 }} />
                </Col>
                <Col md={6} xs={24}>
                  <h2>{ product.name }</h2>
                  <p>
                    <FormattedMessage
                      id="app.visitor.order.orderNumber"
                      description="Order number"
                      defaultMessage="Order number"
                      values={{
                      }}
                    />: { this.props.orderData.name.replace("#","") || this.props.orderNumber }
                  </p>
                  <p>
                    <FormattedMessage
                      id="app.visitor.order.quantityInOrder"
                      description="Quantity of product in order"
                      defaultMessage="Quantity"
                      values={{
                      }}
                    />: { product.quantity }
                  </p>
                  {
                    product.deletedFromStore
                      ? (
                        <Tooltip
                          placement="bottom"
                          title={<FormattedMessage
                            id="app.visitor.order.toolTip"
                            description="This product cannot be returned as it has been removed from the store"
                            defaultMessage="This product cannot be returned as it has been removed from the store"
                            values={{
                            }}
                          />}
                        >
                          <span><FormattedMessage
                            id="app.visitor.order.deletedProduct"
                            description="This product cannot be returned"
                            defaultMessage="This product cannot be returned"
                            values={{
                            }}
                          /></span> <InfoCircleOutlined />
                        </Tooltip>
                      )
                      : null
                  }
                  {
                    product.disabledFromRules && !warrantyEligible
                      ? (
                        <FormattedMessage
                          {...placeholderInput.disabledProduct}
                          values={{
                            email_address: <a style={{ textDecoration: "underline", color: this.props.brandColorText, fontStyle: this.props.brandFontStyle}} target="_blank" href={"mailto:" + this.props.contactEmail}>{this.props.contactEmail}</a>
                          }}
                        />
                      )
                      : null
                  }
                </Col>
                <Col md={8} xs={24} style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}>
                  {
                    product.quantity > 1
                      ? (
                        <Row type="flex" justify="center" align="top">
                          <Col md={24} xs={24}>
                            <FormItem
                              colon={false}
                              label={
                                <FormattedMessage
                                  id="app.visitor.order.quantityInReturn"
                                  description="Quantity of product in return"
                                  defaultMessage="Quantity"
                                  values={{}}
                                />
                              }
                              {...formItemLayout}
                              name={`returnQuantity_${product.id}`}
                              initialValue="1"
                            >
                              <Select
                                disabled={
                                  productUnavailable ||
                                  (!this.getFormValue(`returnItemChecked_${product.id}`) &&
                                    this.getFormValue(`resolution_${product.id}`)?.length > 0)
                                }
                                onChange={(value) => {
                                  this.updateQuantityOfLineItem(value, product.id, product.variant_id);
                                }}
                              >
                                {quantitySelectionElements}
                              </Select>
                            </FormItem>
                          </Col>
                        </Row>
                      )
                      : null
                  }
                  {
                    showReturnTypeSelector
                      ? (
                        <Row type="flex" justify="center" align="top">
                          <Col md={24} xs={24}>
                            <FormItem
                              colon={false}
                              label={
                                <FormattedMessage
                                  id="app.visitor.order.selectReturnType"
                                  description="Customer chooses between a Standard Return and a Warranty Claim"
                                  defaultMessage="Return Type"
                                  values={{}}
                                />
                              }
                              {...formItemLayout}
                              name={`returnType_${product.id}`}
                              initialValue={returnTypeInitialValue}
                            >
                              <Select
                                id={`returnType_${product.id}`}
                                onChange={(value) => this.returnTypeSelected(value, product)}
                                disabled={
                                  !!lockedReturnType ||
                                  (!this.getFormValue(`returnItemChecked_${product.id}`) &&
                                    this.getFormValue(`resolution_${product.id}`)?.length > 0)
                                }
                              >
                                <Option value="standard" key="standard">
                                  <FormattedMessage
                                    id="app.visitor.order.returnTypeStandard"
                                    description="Return Type option: Standard Return"
                                    defaultMessage="Standard Return"
                                  />
                                </Option>
                                <Option value="warranty" key="warranty">
                                  <FormattedMessage
                                    id="app.visitor.order.returnTypeWarranty"
                                    description="Return Type option: Warranty Claim"
                                    defaultMessage="Warranty Claim"
                                  />
                                </Option>
                              </Select>
                            </FormItem>
                          </Col>
                        </Row>
                      )
                      : null
                  }
                  <Row type="flex" justify="center" align="top">
                    <Col  md={24} xs={24}>
                      <FormItem
                        colon={false}
                        label={
                          <FormattedMessage
                            id="app.visitor.order.selectResolution"
                            description="Customer selects the desired action for a product"
                            defaultMessage="Action"
                            values={{}}
                          />
                        }
                        {...formItemLayout}
                        name={`resolution_${product.id}`}
                      >
                        <Select
                          onMouseEnter={() => {
                            if (!this.state[`${product.id}Initiated`]) {
                              this.setState({
                                [`${product.id}Initiated`]: true,
                                [`${product.id}deadline`]: Date.now() + 60000,
                              });
                            }
                          }}
                          id={`resolution_${product.id}`}
                          key={`resolution_${product.id}`}
                          onChange={(value) => {
                            this.resolutionSelected(value, product);
                            this.updateHasExchangeResolution(value, product);
                          }}
                          disabled={
                            productUnavailable ||
                            (!this.getFormValue(`returnItemChecked_${product.id}`) &&
                              this.getFormValue(`resolution_${product.id}`)?.length > 0)
                          }
                        >
                          {this.getAvailableOptions(product.id, product.price, product.variant_id, selectedReturnType)}
                        </Select>
                      </FormItem>
                      {this.state[`dictatResolution${product.id}`] &&
                          this.state[`dictate${product.id}`] && (
                        <span style={{ color: "red", fontSize: "small" }}>
                          <FormattedMessage
                            {...placeholderInput.dictateMessage}
                            values={{
                              bonusAmount: this.state[`dictateAmount${product.id}`],
                              dictateResolution:
                                    this.state[`dictatResolution${product.id}`] === "storeCredit"
                                      ? resolutionOptionsDetail.storeCredit.title
                                      : exchangeResolutionTranslation?.exchange?.title,
                            }}
                          />
                        </span>
                      )}
                    </Col>
                  </Row>
                  { 
                    this.state[`exchangeOptions_${product.id}`] && this.state[`exchangeOptions_${product.id}`].length > 0
                      ? (
                        <>
                          {this.state[`exchangeProductOptions_${product.id}`].map((productOption, index)=>{
                            return(
                              <Row type="flex" justify="space-around" align="middle">
                                <Col md={24} xs={24}>
                                  <FormItem
                                    colon={false}
                                    label={
                                      <FormattedMessage
                                        id="app.visitor.order.exchangeOptionsDescription"
                                        description="Description for dropdown menu containing the exchange variations"
                                        defaultMessage={`Choose new {variableForOptionTitle}`}
                                        values={{
                                          variableForOptionTitle:
                                            this.state[`exchangeOptions_${product.id}`].length === 1
                                              ? 'product'
                                              : productOption.name,
                                        }}
                                      />
                                    }
                                    {...formItemLayout}
                                    name={
                                      this.state[`exchangeOptions_${product.id}`].length === 1
                                        ? `exchangeItem_${product.id}`
                                        : `exchangeItem_${product.id}_${productOption.id}`
                                    }
                                    rules={[
                                      {
                                        required: true,
                                        message: (
                                          <FormattedMessage
                                            id="app.visitor.order.exchangeOptionsErrorRequired"
                                            description="Customer missed filling out the exchange details. This is the associated error message."
                                            defaultMessage="Please select a valid {productOptionName}."
                                            values={{
                                              productOptionName: productOption.name,
                                            }}
                                          />
                                        ),
                                      },
                                    ]}
                                  >
                                    <>
                                      {this.state[`exchangeOptions_${product.id}`].length === 1 ? (
                                        <Select
                                          onChange={() =>
                                            this.formRef.current.setFieldsValue({
                                              [`exchangeItem_${product.id}`]:
                                                this.state[`exchangeOptions_${product.id}`][0].exchangeVariantId,
                                            })
                                          }
                                        >
                                          <Option
                                            value={
                                              this.state[`exchangeOptions_${product.id}`][0].exchangeVariantId
                                            }
                                            key={
                                              this.state[`exchangeOptions_${product.id}`][0].exchangeVariantId
                                            }
                                            disabled={this.state[`exchangeOptions_${product.id}`][0].disabled}
                                            style={{
                                              color:
                                                this.state[`exchangeOptions_${product.id}`][0].disabled &&
                                                'rgba(0, 0, 0, 0.25)',
                                            }}
                                          >
                                            {this.state[`exchangeOptions_${product.id}`][0].disabledReason
                                              ? `${product.title} (${this.state[`exchangeOptions_${product.id}`][0].disabledReason})`
                                              : product.title}
                                          </Option>
                                        </Select>
                                      ) : (
                                        <Select
                                          onChange={(value, option) =>
                                            this.handleExchangeVariantPropertySelection(
                                              value,
                                              productOption,
                                              product.id
                                            )
                                          }
                                          value={productOption.valueSelected}
                                        >
                                          {productOption.values.map((option) => {
                                            const isDisabled = this.isExchangeVariantPropertyDisabled(
                                              option,
                                              productOption,
                                              product.id,
                                              this.state[`exchangeProductOptions_${product.id}`]
                                            );
                                            return (
                                              <Option
                                                value={option}
                                                key={option}
                                                disabled={isDisabled.disabled}
                                                style={{
                                                  color:
                                                    isDisabled.disabled && 'rgba(0, 0, 0, 0.25)',
                                                }}
                                              >
                                                {isDisabled.disabled && isDisabled.disabledReason
                                                  ? `${option} (${isDisabled.disabledReason})`
                                                  : option}
                                              </Option>
                                            );
                                          })}
                                        </Select>
                                      )}
                                    </>
                                  </FormItem>
                                </Col>
                              </Row>
                            )
                          })}
                        </>
                      )
                      : null
                  }
                  {/* displaying product selected for collection exchange or store-wide exchange */}
                  {this.state.advancedExchanges[
                    `products_${product.id}`
                  ]&&this.state.advancedExchanges[
                    `products_${product.id}`
                  ].length > 0 ? (
                      <Row span={24} type="flex" justify="center" align="top">
                        <Col span={24}>
                          <List
                            span={24}
                            style={{ "borderRadius": 4, "background": "#fbfbfd" }}
                            bordered={true}
                            itemLayout="horizontal"
                            dataSource={this.state.advancedExchanges[`products_${product.id}`]}
                            renderItem={(item) => (
                              <List.Item span={24} style={{ position: 'relative' }}>
                                <Button
                                  style={{
                                    position: 'absolute',
                                    background: 'white',
                                    color: 'black',
                                    padding: '0 7px',
                                    borderRadius: '20px',
                                    top: '-10px',
                                    right: '-10px',
                                  }}
                                  onClick={() => this.clearAdvancedExchange(item.lineItemIdToBeExchanged)}
                                >
                                x
                                </Button>
                              
                                <List.Item.Meta
                                  avatar={<img width='100%' src={item.productImage} /> }
                                  title={
                                    <Badge
                                      count={formatMessage({
                                        id:"app.visitor.exchange.recieveItem",
                                        description:"title for item selected for exchange",
                                        defaultMessage:"You'll receive",
                                      })}
                                      style={{ backgroundColor: '#52c41a'}}
                                    />
                                  }
                                  description={item.productName + ' - ' + item.variantTitle}
                                />
                              </List.Item>
                            )}
                          />
                        </Col>
                      </Row>
                    ) : null}
                  <Row type="flex" justify="space-around" align="middle">
                    <Col md={24} xs={24}>
                      <FormItem
                        colon={false}
                        label={
                          <FormattedMessage
                            id="app.visitor.order.returnReason"
                            description="Reason for return of the product"
                            defaultMessage="Reason"
                            values={{}}
                          />
                        }
                        {...formItemLayout}
                        name={`returnReason_${product.id}`}
                      >
                        <Select
                          disabled={
                            productUnavailable ||
                            (!this.getFormValue(`returnItemChecked_${product.id}`) &&
                              this.getFormValue(`resolution_${product.id}`)?.length > 0)
                          }
                          onChange={(value) => {
                            this.onChangeReason(value, product.id);
                          }}
                        >
                          {this.getReturnReasons(selectedReturnType)}
                        </Select>
                      </FormItem>
                    </Col>
                  </Row>

                  {/* Instant Exchange Selection Block */}
                  {
                    this.props.returnSettings.instantExchanges && 
                    this.isExchangeResolution(product.id) && 
                    this.props.type != "giftReturn" && (
                      <>
                        <Row type="flex" justify="space-around" align="middle">
                          <Col md={24} xs={24}>
                            <FormItem
                              label={
                                <FormattedMessage
                                  id="app.visitor.order.InstantexchangeDescription"
                                  description="Description for radio picker for instant/regular exchange."
                                  defaultMessage={`Exchange Type`}
                                />
                              }
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              colon={false}
                              labelAlign="left"
                              style={{ textAlign: "left" }}
                              name={`selectedInstantExchange_${product.id}`}
                              initialValue={true}
                            >
                              <div
                                style={{
                                  border: "1px solid #d9d9d9",
                                  padding: "16px",
                                  borderRadius: "4px",
                                }}
                              >
                                <Radio.Group
                                  buttonStyle="solid"
                                  style={{ width: "100%" }}
                                  defaultValue={true}
                                  onChange={(e) => this.handleExchangeTypeChange(e, product.id)}
                                >
                                  <Radio
                                    value={true}
                                    style={{ display: "block", marginBottom: "12px" }}
                                  >
                                    Instant Exchange
                                    <div
                                      style={{
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                        marginTop: "4px",
                                        marginLeft: "24px",
                                      }}
                                    >
                                      Make a deposit up front and we'll send your new items immediately.
                                      You'll receive a complete refund for the items you send back once
                                      they are approved by the seller.
                                    </div>
                                  </Radio>
                                  <Radio
                                    value={false}
                                    style={{ display: "block", marginBottom: "12px" }}
                                  >
                                    Standard Exchange
                                    <div
                                      style={{
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                        marginTop: "4px",
                                        marginLeft: "24px",
                                      }}
                                    >
                                      Send us the item first, and once we receive your return and verify
                                      stock, we'll ship your exchange item.
                                    </div>
                                  </Radio>
                                </Radio.Group>
                              </div>
                            </FormItem>
                          </Col>
                        </Row>
                      </>
                    )}
                  { 
                    this.getFormValue(`returnItemChecked_${product.id}`) &&
                    this.state[`showNotesField_${product.id}_exchange`] === true &&
                    !this.props.returnSettings?.customizeNoteDisabled
                      ? (
                        <Row type="flex" justify="center" align="top">
                          <Col  md={24} xs={24}>
                            <FormItem
                              colon={false}
                              className="customizeNotes"
                              label={
                                this.props.returnSettings?.customizeNote?.title ? (
                                  this.props.returnSettings?.customizeNote?.title
                                ) : (
                                  <FormattedMessage
                                    id="app.visitor.order.notesTitleExchange"
                                    description="Customer exchanges product and explains the exchange details"
                                    defaultMessage="Customer notes"
                                    values={{}}
                                  />
                                )
                              }
                              {...formItemLayout}
                              name={`notes_${product.id}`}
                              rules={[
                                {
                                  required:
                                    this.getFormValue(`returnItemChecked_${product.id}`) &&
                                    this.props.returnSettings?.customizeNote?.isRequire || true,
                                  message: (
                                    <FormattedMessage
                                      id="app.visitor.order.notesExchangeErrorRequired"
                                      description="Customer missed filling out the exchange details. This is the associated error message."
                                      defaultMessage="Please indicate the details of your exchange."
                                      values={{}}
                                    />
                                  ),
                                },
                              ]}
                            >
                              <p>
                                <TextArea
                                  autoSize
                                  placeholder={formatMessage(placeholderInput.notesExchange)}
                                />
                              </p>
                            </FormItem>
                          </Col>
                        </Row>
                      ) : null}

                  { this.getFormValue(`returnItemChecked_${product.id}`) &&
                  this.state[`showNotesField_${product.id}_general`] === true &&
                  !this.props.returnSettings?.customizeNoteDisabled &&
                  // Don't also show the generic default note field when an Advanced Rule /
                  // Warranty Rule custom note already applies to this product - the customer
                  // would otherwise see two separate "notes" inputs for the same thing.
                  !(this.state.advancedRuleExtraNotesSetting[`${product.id}`]?.length > 0)
                    ? (
                      <Row type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            colon={false}
                            className="customizeNotes"
                            label={
                              this.props.returnSettings?.customizeNote?.title ? (
                                this.props.returnSettings?.customizeNote?.title
                              ) : (
                                <FormattedMessage
                                  id="app.visitor.order.notesTitleExchange"
                                  description="Customer exchanges product and explains the exchange details"
                                  defaultMessage="Customer notes"
                                  values={{}}
                                />
                              )
                            }
                            {...formItemLayout}
                            name={`notes_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) &&
                                  this.props.returnSettings?.customizeNote?.isRequire || false,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the customer note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <p>
                              <TextArea
                                autoSize
                                placeholder={formatMessage(placeholderInput.notesGeneral)}
                              />
                            </p>
                          </FormItem>
                        </Col>
                      </Row>
                    )
                    : null
                  }

                  { this.getFormValue(`returnItemChecked_${product.id}`) && this.state[`showNotesField_${product.id}_warranty`] === true &&
                    !this.props.returnSettings?.customizeNoteDisabled &&
                    // Same as the general note field above - a per-rule custom note already
                    // covers this, so don't also show the legacy warranty notes field.
                    !(this.state.advancedRuleExtraNotesSetting[`${product.id}`]?.length > 0)
                    ? (
                      <Row type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            className="warrantyNotes"
                            colon={false}
                            label={
                              this.props.returnSettings?.warrantyCustomizeNotes?.title || (
                                <FormattedMessage
                                  id="app.visitor.order.warrantyNotesTitleExchange"
                                  description="Customer explains the warranty details"
                                  defaultMessage="Warranty notes"
                                />
                              )
                            }
                            {...formItemLayout}
                            name={`warrantyNotes_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) &&
                                  this.props.returnSettings?.warrantyCustomizeNotes?.isRequire || false,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.warrantyNotesExchangeErrorRequired"
                                    description="Customer missed filling out the warranty note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <p>
                              <TextArea
                                autoSize
                                placeholder={formatMessage(placeholderInput.notesGeneral)}
                              />
                            </p>
                          </FormItem>
                        </Col>
                      </Row>
                    )
                    : null
                  }
                  
                  { this.getFormValue(`returnItemChecked_${product.id}`) && this.state[
                    `showNotesField_${product.id}_general`
                  ] === true && this.state.additionalFields.length > 0 && this.state.additionalFields.map((i, index) => {
                    if(i.type === 'note') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24} style={{ whiteSpace: 'break-spaces' }}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            style={{ whiteSpace: 'break-spaces' }}
                            name={`notes_${i.title}_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) && i.isRequire,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the customer note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <TextArea
                              onChange={(e) => {
                                this.handleCustomNoteChange(product.id, {
                                  title: i.title,
                                  value: e.target.value,
                                  target: 'additionalFields',
                                });
                              }}
                            />
                          </FormItem>
                        </Col>
                      </Row>
                    } else if (i.type === 'checkbox') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            name={`checkbox_${i.title}_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) && i.isRequire,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the customer note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <>
                              {i.options.map((option) => (
                                <Checkbox
                                  key={option}
                                  onChange={(e) => {
                                    this.handleCheckboxChange(product.id, {
                                      title: i.title,
                                      option,
                                      checked: e.target.checked,
                                      target: 'additionalFields',
                                    });
                                  }}
                                  style={{ marginLeft: 0 }}
                                >
                                  {option}
                                </Checkbox>
                              ))}
                            </>
                          </FormItem>
                        </Col>
                      </Row>
                    } else if (i.type === 'radio-button') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            name={`radio_${i.title}_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) && i.isRequire,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the customer note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={(e) => {
                                this.handleRadioNoteChange(product.id, {
                                  title: i.title,
                                  option: e.target.value,
                                  target: 'additionalFields',
                                });
                              }}
                            >
                              {i.options.map((option) => (
                                <Radio key={option} value={option}>
                                  {option}
                                </Radio>
                              ))}
                            </Radio.Group>
                          </FormItem>
                        </Col>
                      </Row>
                    }
                  })}
                  

                  { this.getFormValue(`returnItemChecked_${product.id}`) && this.state[
                    `showNotesField_${product.id}_warranty`
                  ] === true && this.state.warrantyAdditionalFields.length > 0 && this.state.warrantyAdditionalFields.map((i, index) => {
                    if(i.type === 'note') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24} style={{ whiteSpace: 'break-spaces' }}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            style={{ whiteSpace: 'break-spaces' }}
                            name={`warrantyNotes_${i.title}_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) && i.isRequire,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.warrantyNotesExchangeErrorRequired"
                                    description="Customer missed filling out the warranty note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <TextArea
                              onChange={(e) => {
                                this.handleCustomNoteChange(product.id, {
                                  title: i.title,
                                  value: e.target.value,
                                  target: 'warrantyAdditionalFields',
                                });
                              }}
                            />
                          </FormItem>
                        </Col>
                      </Row>
                    } else if (i.type === 'checkbox') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            name={`warrantyCheckbox_${i.title}_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) && i.isRequire,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the warranty note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <>
                              {i.options.map((option) => (
                                <Checkbox
                                  key={option}
                                  onChange={(e) => {
                                    this.handleCheckboxChange(product.id, {
                                      title: i.title,
                                      option,
                                      checked: e.target.checked,
                                      target: 'warrantyAdditionalFields',
                                    });
                                  }}
                                  style={{ marginLeft: 0 }}
                                >
                                  {option}
                                </Checkbox>
                              ))}
                            </>
                          </FormItem>
                        </Col>
                      </Row>
                    } else if (i.type === 'radio-button') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            name={`warrantyRadio_${i.title}_${product.id}`}
                            rules={[
                              {
                                required:
                                  this.getFormValue(`returnItemChecked_${product.id}`) && i.isRequire,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.warrantyNotesExchangeErrorRequired"
                                    description="Customer missed filling out the warranty note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={(e) => {
                                this.handleRadioNoteChange(product.id, {
                                  title: i.title,
                                  option: e.target.value,
                                  target: 'warrantyAdditionalFields',
                                });
                              }}
                            >
                              {i.options.map((option) => (
                                <Radio key={option} value={option}>
                                  {option}
                                </Radio>
                              ))}
                            </Radio.Group>
                          </FormItem>
                        </Col>
                      </Row>
                    }
                  })}

                  {this.getFormValue(`returnItemChecked_${product.id}`) &&
                  this.state.advancedRuleExtraNotesSetting[`${product.id}`]?.length > 0 && this.state.advancedRuleExtraNotesSetting[`${product.id}`].map((i, index) => {
                    // Rules saved before the type dropdown was explicitly interacted with can
                    // have configExtraNote.type unset even though "Note" is what the dashboard
                    // shows as selected (defaultValue vs value bug) - default to 'note' so those
                    // already-saved rules still render instead of silently showing nothing.
                    if(i.type === 'note' || !i.type) {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24} style={{ whiteSpace: 'break-spaces' }}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            style={{ whiteSpace: 'break-spaces' }}
                            name={`note_${i.title}_${product.id}`}
                            rules={[
                              {
                                // This block only renders when a custom rule note applies to
                                // this product (see the .length > 0 guard above), so whether
                                // it's required should depend only on i.isRequired - it must
                                // not also require showNotesField_..._general, which is the
                                // generic default note's own visibility flag and is explicitly
                                // false for warranty claims, silently defeating "Required?"
                                // for every warranty rule note.
                                required: !!i.isRequired,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the customer note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <TextArea
                              onChange={(e) => {
                                this.handleCustomNoteChange(product.id, {
                                  title: i.title,
                                  value: e.target.value,
                                  target: 'advancedRuleExtraNotesSetting',
                                });
                              }}
                            />
                          </FormItem>
                        </Col>
                      </Row>
                    } else if (i.type === 'checkbox') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            name={`checkbox_${i.title}_${product.id}`}
                            rules={[
                              {
                                // This block only renders when a custom rule note applies to
                                // this product (see the .length > 0 guard above), so whether
                                // it's required should depend only on i.isRequired - it must
                                // not also require showNotesField_..._general, which is the
                                // generic default note's own visibility flag and is explicitly
                                // false for warranty claims, silently defeating "Required?"
                                // for every warranty rule note.
                                required: !!i.isRequired,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the customer note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <>
                              {i.options.map((option) => (
                                <Checkbox
                                  key={option}
                                  defaultChecked={false}
                                  onChange={(e) => {
                                    this.handleCheckboxChange(product.id, {
                                      title: i.title,
                                      option,
                                      checked: e.target.checked,
                                      target: 'advancedRuleExtraNotesSetting',
                                    });
                                  }}
                                >
                                  {option}
                                </Checkbox>
                              ))}
                            </>
                          </FormItem>
                        </Col>
                      </Row>
                    } else if (i.type === 'radio-button') {
                      return <Row key={index} type="flex" justify="center" align="top">
                        <Col md={24} xs={24}>
                          <FormItem
                            colon={false}
                            label={i.title}
                            {...formItemLayout}
                            name={`radio_${i.title}_${product.id}`}
                            rules={[
                              {
                                // This block only renders when a custom rule note applies to
                                // this product (see the .length > 0 guard above), so whether
                                // it's required should depend only on i.isRequired - it must
                                // not also require showNotesField_..._general, which is the
                                // generic default note's own visibility flag and is explicitly
                                // false for warranty claims, silently defeating "Required?"
                                // for every warranty rule note.
                                required: !!i.isRequired,
                                message: (
                                  <FormattedMessage
                                    id="app.visitor.order.notesExchangeErrorRequired"
                                    description="Customer missed filling out the customer note. This is the associated error message."
                                    defaultMessage="Please indicate the details of your return."
                                  />
                                ),
                              },
                            ]}
                          >
                            <Radio.Group
                              onChange={(e) => {
                                this.handleRadioNoteChange(product.id, {
                                  title: i.title,
                                  option: e.target.value,
                                  target: 'advancedRuleExtraNotesSetting',
                                });
                              }}
                            >
                              {i.options.map((option) => (
                                <Radio key={option} value={option}>
                                  {option}
                                </Radio>
                              ))}
                            </Radio.Group>
                          </FormItem>
                        </Col>
                      </Row>
                    }
                  })}
                </Col>
              </Row>
              <React.Fragment>
                { insertDivider }
              </React.Fragment>
            </React.Fragment>
          )
        return productElement;
      });

    return(
      <React.Fragment>
        {(this.state.showProducts && !this.state.shouldHideStoreWideExchangesModal) && 
        <StoreWideProducts
          {...this.props}
          visible={this.state.showProducts}
          hideProducts={this.hideProducts}
          handleSelectedProduct={this.handleSelectedProduct}
          currentProduct={this.state.currentPoduct}
          itemQuantity={this.state.itemQuantity}
        />}
        <Card
          title={
            <FormattedMessage
              id="app.visitor.order.headline"
              description="Title of the second step of the customer portal process ('Order')"
              defaultMessage="Select products to return"
              values={{
              }}
            />
          }
          className="textCenter"
        >
          {/* This will open drawer of the products to select for collection exchanges */}
          {this.state.exchangeOptionsVisible ? (
            <ExchangeOptions
              {...this.props}
              lineItemIdToBeExchanged={this.state.advancedExchangeLineItemId}
              showProductsDrawer={this.showExchangeOptions.bind(this)}
              companyIdentifier={this.props.companyIdentifier}
              returnNumber={this.props.returnNumber}
              updateExchangedProduct={this.updateExchangedProduct.bind(this)}
              advancedExchangeOptions={
                this.state.selectedAdvancedExchangeOptions
              }
              visible={this.state.exchangeOptionsVisible}
              closeExchangeOptions={this.closeExchangeOptions.bind(this)}
              currentProduct={this.state.currentPoduct}
            />
          ) : null}
          <Form onFinish={this.handleSubmit} ref={this.formRef}>
            {productList}
            <Divider />
            <FormItem>
              <Row type="flex" justify="center" align="top">
                <Col>
                  <Button type="primary" id="order" htmlType="submit" disabled={this.state.submitButtonDisabled || this.state.loadingExchangeOptions} style={{ backgroundColor: this.props.brandColorButton, borderColor: this.props.brandColorButton }}>
                    <span style={{ color: this.props.brandColorButtonText, fontStyle: this.props.brandFontStyle }}>
                      <FormattedMessage
                        id="app.visitor.order.buttonSubmit"
                        description="Button to continue from step 'order' to 'resolution'"
                        defaultMessage="Continue"
                        values={{
                        }}
                      />
                    </span>
                  </Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </Card>
      </React.Fragment>
    );
  }
}

const exchangeResolutionTranslation = {
  exchange: {
    title: (
      <FormattedMessage
        id="app.visitor.resolutions.exchange"
        description="Title of the resolution Exchange"
        defaultMessage="Exchange"
      />
    )
  }
}

const resolutionOptionsDetail = {
  storeCredit: {
    title: (
      <FormattedMessage
        id="app.visitor.resolutions.storeCreditTitle"
        description="Title of the refund method: store credit"
        defaultMessage="Store credit"
      />
    ),
    identifier: "storeCredit",
    description: (
      <FormattedMessage
        id="app.visitor.resolutions.storeCreditDescription"
        description="Description of the refund method: store credit"
        defaultMessage="We'll apply the refund to your account."
      />
    ),
    refundTime: (
      <FormattedMessage
        id="app.visitor.resolutions.storeCreditRefundTime"
        description="Description of the refund method: store credit"
        defaultMessage="Estimated refund timing: Instant once we receive the original item(s)."
      />
    ),
  },
  exchangeItem: {
    identifier: "exchangeItem",
    title: (
      <FormattedMessage
        id="app.visitor.resolutions.exchangeItemTitle"
        description="Title of the refund method: exchange"
        defaultMessage="Exchange for a different variant"
      />
    ),
    description: (
      <FormattedMessage
        id="app.visitor.resolutions.exchangeItemDescription"
        description="Description of the refund method: exchange"
        defaultMessage="We'll exchange the item(s) if available."
      />
    ),
    refundTime: (
      <FormattedMessage
        id="app.visitor.resolutions.exchangeItemRefundTime"
        description="Description of the refund method: exchange"
        defaultMessage="Estimated refund timing: Instant once we receive the original item(s)."
      />
    ),
  },
  storeWideExchange: {
    identifier: "storeWideExchange",
    title: (
      <FormattedMessage
        id="app.visitor.resolutions.storeWideExchangeTitle"
        description="Title of the refund method: storeWideExchange"
        defaultMessage="Exchange for a different product store-wide"
      />
    ),
    description: (
      <FormattedMessage
        id="app.visitor.resolutions.storeWideExchangeDescription"
        description="Description of the refund method: storeWideExchange"
        defaultMessage="We'll exchange the item(s) if available."
      />
    ),
    refundTime: (
      <FormattedMessage
        id="app.visitor.resolutions.storeWideExchangeRefundTime"
        description="Description of the refund method: storeWideExchange"
        defaultMessage="Estimated refund timing: Instant once we receive the original item(s)."
      />
    ),
  },
  advancedExchange: {
    identifier: "advancedExchange",
    title: (
      <FormattedMessage
        id="app.visitor.resolutions.advancedExchangeOptionTitle"
        description="Title of the Collection Exchange Option"
        defaultMessage="Exchange for a product from a similar collection"
      />
    ),
    description: (
      <FormattedMessage
        id="app.visitor.resolutions.advanceExchangeOptionDescription"
        description="Description of the refund method: exchange"
        defaultMessage="We'll exchange the item(s) if available."
      />
    ),
    refundTime: (
      <FormattedMessage
        id="app.visitor.resolutions.advanceExchangeOptionRefundTime"
        description="Description of the refund method: exchange"
        defaultMessage="Estimated refund timing: Instant once we receive the original item(s)."
      />
    ),
  },
  originalPaymentMethod: {
    identifier: "originalPaymentMethod",
    title: (
      <FormattedMessage
        id="app.visitor.resolutions.originalPaymentMethodTitle"
        description="Title of the refund method: original payment"
        defaultMessage="Refund to original payment method"
      />
    ),
    description: (
      <FormattedMessage
        id="app.visitor.resolutions.originalPaymentMethodDescription"
        description="Description of the refund method: original payment"
        defaultMessage="We'll process your refund to your original payment method."
      />
    ),
    refundTime: (
      <FormattedMessage
        id="app.visitor.resolutions.originalPaymentMethodRefundTime"
        description="Description of the refund method: original payment"
        defaultMessage="Estimated refund timing: 5-7 business days after we receive the original item(s)."
      />
    ),
  },
  refundToCustom1: {
    identifier: "refundToCustom1",
    title: "",
    description: "",
    refundTime: "",
  },
  refundToCustom2: {
    identifier: "refundToCustom2",
    title: "",
    description: "",
    refundTime: "",
  },
  refundToCustom3: {
    identifier: "refundToCustom3",
    title: "",
    description: "",
    refundTime: "",
  }
}

export default injectIntl(Order);
